export default __webpack_public_path__ + "static/roadmap-mobile_en_v2-7c822fe0d651737e0d8c46e15798226a.png";